let summaryTableData = [
  {
    companyName: '会社A',
    title: '合計',
    day1: 36300,
    day2: 27225,
    day3: 46763,
    day4: 24525,
    day5: 36300,
    day6: 31300,
    day7: 28300,
  },
  {
    companyName: '会社B',
    title: '合計',
    day1: 44138,
    day2: 34138,
    day3: 33750,
    day4: 34525,
    day5: 32525,
    day6: 22670,
    day7: 12467,
  },
  {
    companyName: '会社C',
    title: '合計',
    day1: 26800,
    day2: 27600,
    day3: 36800,
    day4: 36800,
    day5: 39800,
    day6: 32567,
    day7: 22789,
  },
]

let summaryTableDataCost = [
  {
    companyName: '会社A',
    title: '',
    day1: 53000,
    day2: 41000,
    day3: 52000,
    day4: 39000,
    day5: 46000,
    day6: 0,
    day7: 0,
  },
  {
    companyName: '会社B',
    title: '',
    day1: 110000,
    day2: 132000,
    day3: 98000,
    day4: 127000,
    day5: 89700,
    day6: 0,
    day7: 0,
  },
  {
    companyName: '会社C',
    title: '',
    day1: 65700,
    day2: 64500,
    day3: 67000,
    day4: 65300,
    day5: 67900,
    day6: 0,
    day7: 0,
  },
]

let summaryTableDataSales = [
  {
    companyName: '会社A',
    title: '売り上げ',
    day1: 49000,
    day2: 40500,
    day3: 48700,
    day4: 30000,
    day5: 43000,
    day6: 25000,
    day7: 25000,
  },
  {
    companyName: '会社B',
    title: '売り上げ',
    day1: 120000,
    day2: 145000,
    day3: 107000,
    day4: 150000,
    day5: 92500,
    day6: 50000,
    day7: 50000,
  },
  {
    companyName: '会社C',
    title: '売り上げ',
    day1: 78000,
    day2: 56800,
    day3: 82500,
    day4: 53100,
    day5: 71200,
    day6: 36000,
    day7: 36000,
  },
]

let summaryTableDataProfit = [
  {
    companyName: '会社A',
    title: '利益率',
    day1: -0.1816,
    day2: -0.3123,
    day3: -0.2678,
    day4: -0.3,
    day5: -0.2698,
    day6: 0.2256,
    day7: 0.4587,
  },
  {
    companyName: '会社B',
    title: '利益率',
    day1: 0.0833,
    day2: 0.897,
    day3: 0.841,
    day4: 0.1533,
    day5: 0.0303,
    day6: 0.3456,
    day7: -0.678,
  },
  {
    companyName: '会社C',
    title: '利益率',
    day1: 0.1577,
    day2: -0.1356,
    day3: 0.1879,
    day4: -0.2298,
    day5: 0.0463,
    day6: 0.2356,
    day7: 1,
  },
]

let summaryTableDataPerson = [
  {
    companyName: '会社A',
    male: 20,
    female: 13,
  },
  {
    companyName: '会社B',
    male: 40,
    female: 21,
  },
  {
    companyName: '会社C',
    male: 32,
    female: 0,
  },
]

module.exports = {
  summaryTableData,
  summaryTableDataCost,
  summaryTableDataSales,
  summaryTableDataProfit,
  summaryTableDataPerson,
}
